import React from 'react';
import Icon from '../../components/mweb/Icon/Icon';
import Button from '../../components/common/Button/Button';

const COD = props => {
  const {
    title = 'Pay On Delivery',
    selectedMode,
    onPaymentModeChange,
    onPlaceOrder,
    isCodEnable,
    codMessage,
    isPodEnable,
    podMessage,
  } = props;
  const podModes = [
    {
      key: 'pod',
      title: 'By SMS links or QR code',
      isActive: isPodEnable,
      message:
        podMessage || (!isPodEnable && 'POD is not available for this order'),
      icon: 'icon-payment-pod',
    },
    {
      key: 'cod',
      title: 'By Cash',
      isActive: isCodEnable,
      message:
        codMessage || (!isCodEnable && 'COD is not available for this order'),
      icon: 'icon-payment-currency-note',
    },
  ];
  const onPay = pMode => {
    const payDetails = { mode: pMode.key };
    onPlaceOrder(payDetails);
  };
  const onModeClick = pMode => {
    if (pMode.isActive) {
      onPaymentModeChange(pMode.key);
    }
  };
  return (
    <React.Fragment>
      <div className="payment-mode-panel cod">
        <div className="payment-mode-panel--title">{title}</div>
        {podModes.length > 0 &&
          podModes.map((pMode, index) => (
            <React.Fragment key={pMode.key}>
              <div
                className={[
                  'payment-mode-panel--item',
                  selectedMode === pMode.key ? 'active' : '',
                  index === podModes.length - 1 ? 'last-item' : '',
                ].join(' ')}
                onClick={() => onModeClick(pMode)}
              >
                <div
                  className={`flex-align-items-center ${
                    !pMode.isActive ? 'cod-disabled' : ''
                  }`}
                >
                  <div className="payment-mode-panel--item--illustration">
                    <Icon class={pMode.icon} height={26} width={45} />
                  </div>
                  <div className="payment-mode-panel--item--name">
                    {pMode.title}
                  </div>
                  {pMode.isActive && (
                    <div className="payment-mode-panel--item--radio">
                      {selectedMode === pMode.key ? (
                        <Icon size={17} class="icon-common-radio-selected" />
                      ) : (
                        <Icon size={17} class="icon-common-radio-unselected" />
                      )}
                    </div>
                  )}
                </div>
                {pMode.message && (
                  <div className="cod-disabled-message">{pMode.message}</div>
                )}
              </div>
              {selectedMode === pMode.key && (
                <div className="cod-cta">
                  <Button
                    className="button button-primary medium"
                    onClick={() => onPay(pMode)}
                  >
                    Place Order
                  </Button>
                </div>
              )}
            </React.Fragment>
          ))}
      </div>
      <div className="section-divider" />
    </React.Fragment>
  );
};

export default COD;
